module.exports = __webpack_public_path__ + "img/SKMG14_보호구.91e0f4a7.jpg";